import {
  refreshMetrics,
  revokeResult,
  signalPlanChange,
} from "./core.js"
import { refreshCropMetrics } from "./crop.js"
import { refreshWorkerControl } from "./workers.js"

let initialized = false

export function setupEffectsUi() {
  if (initialized) return
  initialized = true
  const blurSlider = document.getElementById("motionBlurSlider")
  const blurValue = document.getElementById("motionBlurValue")
  const blurHelper = document.getElementById("motionBlurHelper")
  const performanceNote = document.getElementById("performanceNote")

  const refreshBlurUi = () => {
    const amount = Math.max(0, Math.min(100, Number(blurSlider?.value) || 0))
    if (blurValue) blurValue.textContent = `${amount}%`
    if (blurHelper && !amount) blurHelper.textContent = "Off"
  }

  const blurChanged = () => {
    refreshBlurUi()
    revokeResult(true)
    refreshMetrics()
    refreshCropMetrics()
    refreshWorkerControl()
    signalPlanChange("motionBlurSlider")
  }

  blurSlider?.addEventListener("input", blurChanged)
  blurSlider?.addEventListener("change", blurChanged)

  addEventListener("converter-frame-cache", (event) => {
    const { output = 0, unique = 0, reused = 0 } = event.detail || {}
    if (!performanceNote || output < 1) return
    performanceNote.textContent = reused
      ? `${output} output frames · ${unique} unique frames rendered · ${reused} matching frames reused.`
      : `${output} output frames · ${unique} unique frames rendered.`
  })

  addEventListener("converter-stabilizer-complete", (event) => {
    const zoom = Number(event.detail?.zoom) || 1
    const rotation = Number(event.detail?.maximumRotation) || 0
    const helper = document.getElementById("stabilizerHelper")
    if (helper && document.getElementById("motionStabilizerToggle")?.checked) {
      helper.textContent = `Applied translation + rotation · edge zoom ${zoom.toFixed(3)}× · max rotation ${rotation.toFixed(2)}°`
    }
  })

  refreshBlurUi()
  console.assert(blurSlider, "Motion blur slider required")
}
